<template>
    <div class="scientist-area ptb-100" id="echipa-noastra">
        <div class="container">
            <div class="section-title">
                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Echipa</span>
                <h2>Meșterii din Atelierul Nostru<span class="overlay"></span></h2>
                <p>Performanța nu este generată de sisteme, ci de oamenii care le concep. Suntem un grup de specialiști pasionați, aduși împreună de dorința de a construi soluții software care fac cu adevărat diferența.</p>
            </div>

            <div class="row">

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/eugen-paraschiv.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Eugen Paraschiv</h3>
                            <span>Consultant Business</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/adi-secheli.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Adrian Secheli</h3>
                            <span>Consultant Software</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/daniel-buhai.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Daniel Buhai</h3>
                            <span>Dezvoltator Software</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/andrei-ruse.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Andrei Ruse</h3>
                            <span>Consultant Software</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/doina-popescu.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Doina Popescu</h3>
                            <span>Contabilitate</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/ioana-buhai.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Ioana Buhai</h3>
                            <span>Specialist Marketing</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/briana-paraschiv.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Briana Paraschiv</h3>
                            <span>Support Tehnic</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="single-scientist-item-box">
                        <div class="image">
                            <img src="../assets/images/team/andrei-necula.jpg" alt="image">

                            <!-- <ul class="social">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul> -->
                        </div>
                        <div class="content">
                            <h3>Andrei Necula</h3>
                            <span>Support Tehnic</span>
                            <!-- <p><br>Cu peste 12 ani de experiență în dezvoltarea de sisteme ERP, Andrei este expertul nostru în arhitecturi scalabile. Pasiunea lui este să "traducă" nevoile de business în cod curat și eficient, asigurându-se că fiecare soluție pe care o construim este nu doar funcțională, ci și o plăcere de utilizat.</p> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASEchipaNoastra'
}
</script>